import React from 'react';
import {Query} from '@apollo/react-components';
import styled from 'styled-components';
import t from 'prop-types';
import {groupBy, prop, toPairs} from 'ramda';
import {withRouter} from 'react-router';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import Loading from '../molecules/Loading';
import ErrorPage from '../pages/ErrorPage';
import gql from 'graphql-tag';
import Empty from '../molecules/Empty';

const GET_DOCUMENTS = gql`
  query System($id: ID!) {
    system(id: $id) {
      id
      documents{
        name
        title
        link
      }
    }
  }
`;

const DocumentCategoryList = styled.ul``;
const DocumentCategory = styled.li``;
const CategoryTitle = styled.div`
  margin-bottom: 6px;
  font-size: 20px;
`;
const DocumentList = styled.ul`
  margin-bottom: 12px;
`;
const DocumentItem = styled.li`
  margin-bottom: 6px;
`;
const DocumentName = styled.span`
  margin-right: 12px;
`;
const DocumentLink = styled.a`
  margin-right: 12px;
`;
const Document = styled.div`
  display: flex;
`;

export const DocumentsTree = ({data}) => {
  const documentCategories = toPairs(groupBy(prop('name'), data));
  return (
    <DocumentCategoryList>
      {documentCategories.map(([name, documents]) => (
        <DocumentCategory>
          <CategoryTitle>{name}</CategoryTitle>
          <DocumentList>
            {documents.map(doc => (
              <DocumentItem>
                <Document>
                  <DocumentLink href={doc.link} target="_blank">
                    <DocumentName>{doc.title}</DocumentName>
                    <OpenInNewIcon style={{fontSize: '18px', marginBottom: '2px'}}/>
                  </DocumentLink>
                </Document>
              </DocumentItem>
            ))}
          </DocumentList>
        </DocumentCategory>
      ))}
    </DocumentCategoryList>
  );
};

DocumentsTree.propTypes = {
  data: t.array,
};

const Documents = ({match: {params: {id}}}) => (
  <Query query={GET_DOCUMENTS} variables={{id}}>
    {({loading, error, data}) => {
      if (error) {
        return <ErrorPage error={error} />;
      }
      if (loading) {
        return <Loading loading={loading} message="Fetching documents..."/>;
      }
      const {system: {documents}} = data;
      return documents.length === 0
        ? <Empty />
        : <DocumentsTree data={documents} />;
    }}
  </Query>
);

Documents.propTypes = {
  match: t.object,
};

export default withRouter(Documents);
